import { render } from "./Rotate.vue?vue&type=template&id=170f0cf7"
import script from "./Rotate.vue?vue&type=script&lang=ts"
export * from "./Rotate.vue?vue&type=script&lang=ts"
script.render = render

export default script